import { render, staticRenderFns } from "./fault-popup.vue?vue&type=template&id=2a70d7a4&scoped=true&"
import script from "./fault-popup.vue?vue&type=script&lang=js&"
export * from "./fault-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70d7a4",
  null
  
)

export default component.exports